import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../logo.svg';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="cp-navbar">
      <div className="cp-navbar-inner">
        <NavLink to="/" className="cp-navbar-brand" onClick={closeMenu}>
          <img src={logo} className="cp-navbar-logo" alt="Counterpoint Software" />
          <span className="cp-navbar-name">counterpoint software</span>
        </NavLink>

        <button
          className={`cp-navbar-toggler ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span /><span /><span />
        </button>

        <div className={`cp-navbar-links ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/subquery" className={({ isActive }) => isActive ? 'cp-nav-link active' : 'cp-nav-link'} onClick={closeMenu}>SubQuery</NavLink>
          <NavLink to="/subspace" className={({ isActive }) => isActive ? 'cp-nav-link active' : 'cp-nav-link'} onClick={closeMenu}>Subspace</NavLink>
          <NavLink to="/thegraph" className={({ isActive }) => isActive ? 'cp-nav-link active' : 'cp-nav-link'} onClick={closeMenu}>The Graph</NavLink>
          <NavLink to="/celestia" className={({ isActive }) => isActive ? 'cp-nav-link active' : 'cp-nav-link'} onClick={closeMenu}>Celestia</NavLink>
          <a href="mailto:info@counterpoint.software?subject=Website Contact" className="cp-nav-cta">Get in touch</a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
